export default function registerEstateCarousel(Alpine) {
  Alpine.data("carousel", () => ({
    down: false,
    startX: 0,
    startScroll: 0,
    moved: false,

    init() {
      const track = this.$el;
      const step = () => (track.querySelector("a")?.offsetWidth || track.clientWidth) + 16;

      document
        .querySelectorAll('[data-scroll="next"]')
        .forEach((b) => b.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" })));
      document
        .querySelectorAll('[data-scroll="prev"]')
        .forEach((b) => b.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" })));
    },

    start(e) {
      this.down = true;
      this.moved = false;
      this.startX = e.clientX;
      this.startScroll = this.$el.scrollLeft;
      this.$el.classList.add("cursor-grabbing");
    },

    move(e) {
      if (!this.down) return;
      const dx = e.clientX - this.startX;
      if (Math.abs(dx) > 5) this.moved = true;
      this.$el.scrollLeft = this.startScroll - dx;
    },

    end() {
      this.down = false;
      this.$el.classList.remove("cursor-grabbing");
    },

    // swallow the click that fires after a drag, so it doesn't navigate
    click(e) {
      if (this.moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
  }));
}
